import React from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button, CardImg, 
  CardImgOverlay, Progress, Form,Input,FormFeedback, FormGroup } from 'reactstrap';
import noImage from 'assets/img/users/no-image.jpg';
import { connect } from 'react-redux';
import { CampaignAction } from 'redux/actions';
import { useParams } from "react-router-dom";
import { TableCell, TableRow, Table } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DateFormatTimeZone as DateFormat } from 'hooks';
import { CONSTANTS } from '../../constants';
import { Map, TileLayer, Circle } from "react-leaflet";
import FullscreenControl from 'react-leaflet-fullscreen';
import moment from 'moment';
import 'react-leaflet-fullscreen/dist/styles.css';
import PopupWindow from 'components/ModalPopup';
import PageSpinner from 'components/PageSpinner';
import { IoIosArrowForward } from "react-icons/io";


import {
    MdAdsClick, MdOutlineComment, MdBookmarkBorder, MdOutlineFavoriteBorder, MdOutlineVisibility,
    MdOutlineShare
} from 'react-icons/md';
import Skeleton from '@mui/material/Skeleton';
import DateRangePickerComp from 'components/DatePicker/DateRangePicker';
import ReactHlsPlayer from 'react-hls-player';

const CampaignDetails = (props) => {
    const navigate = useNavigate();
    const { CURRENCY } = CONSTANTS;
    const { campaignId } = useParams();
    const [declinePopup, setDeclinePopup] = React.useState(false);
    const [error, setError] = React.useState(false);

    const [declineError, setDeclineError] = React.useState(false);
    const [declineReason, setDeclineReason] = React.useState();


    
    const [campaignStatus, setCampaignStatus] = React.useState(null);
    let [filters, setFilters] = React.useState(null);
    React.useEffect(() => {
        props.getCampaignsData({ id: campaignId });
        handleSeach();
        setDeclinePopup(false);
        setDeclineError(false);
        setDeclineReason('');
    }, [props.statusUpdated])

    const handleSeach = () => {
        const startDateString = filters && filters.date_range && filters.date_range.startDate ? moment(filters.date_range.startDate).format('YYYY-MM-DD') : '';
        const endDateString = filters && filters.date_range && filters && filters.date_range.endDate ? moment(filters && filters.date_range.endDate).format('YYYY-MM-DD') : '';
        let filter = {
            id: campaignId,
            start_date: startDateString,
            end_date: endDateString
        }
        props.getCampaignInsight(filter);
    }

    React.useEffect(() => {
        props.getCampaignName((props.campaign && props.campaign.campaign_name) ? props.campaign.campaign_name : '');
    }, [props.campaign])

    const regionLocation = (data, column) => {

        const colData = JSON.parse(data[`${column}`]);
        return (
            <div>
                <div style={{ marginBottom: 10 }}>
                    <div><b>Target Regions:</b></div>
                    {
                        (colData && colData.length > 0) ? colData.map((item) => <div>{item.location}</div>) : ''
                    }
                </div>
            </div>
        )
    }

    const campaignLocationMap = (data, column) => {



        const colData = JSON.parse(data[`${column}`]);
        const latitude = (colData && colData.latitude)?colData.latitude:'';
        const longitude = (colData && colData.longitude)?colData.longitude:'';
      
        return (<div>
            <div style={{ marginBottom: 10 }}>
                <div><b>Target Location:</b> </div>
                <div>{`${(colData && colData.address)?colData.address:''}`}</div>
                <div>Lat: {(colData && colData.latitude)?colData.latitude:''}</div>
                <div>Long: {(colData && colData.longitude)?colData.longitude:''}</div>
                <div>Radius: {(colData && colData.radius)?colData.radius:''}</div>
            </div>

            <div>
                <Map
                    center={{
                        lat: latitude,
                        lng: longitude,
                    }}
                    zoom={6}
                    scrollWheelZoom={false}
                    style={{ border: '1px solid', borderRadius: '5px', height: (props.height) ? props.height : 400, width: (props.width) ? props.width : '100%' }}>
                    <TileLayer
                        noWrap={true}
                        //attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    <Circle
                        center={[latitude, longitude]}
                        pathOptions={{ color: 'red' }}
                        radius={(colData && colData.radius)?parseInt(colData.radius) * 1609.34:0}>
                    </Circle>
                    <FullscreenControl position="topleft" />

                </Map>
            </div>
        </div>);
    }

    const columnsData = [
        [
            { name: 'location_type', label: 'Location Type', colType: 'single' }
        ],
        [
            { name: 'ad_start', label: 'Ad Start',highlight:true },
            { name: 'ad_end', label: 'Ad End', highlight:true },
            { name: 'totalDuration', label: 'Total Duration',highlight:true },
            { name: 'total_ad_budget', label: 'Total Ad Budget',highlight:true },
            { name: "per_day_budget", label: "Budget Per Day",highlight:true },
            { name: 'cost_per_click', label: 'Estimated Cost Per Click',highlight:true },
            { name: 'cost_per_view', label: 'Estimated Cost Per View',highlight:true },
            { name: 'clicks_per_day_estimated', label: 'Clicks Per Day Estimated Cost',highlight:true },
            { name: 'estimated_views_per_day', label: 'Estimated Views Per Day Cost',highlight:true },
        ],

        [
            { name: 'campaign_name', label: 'Campaign Name' },


            { name: 'username', label: 'Customer' },
            { name: 'ad_set_name', label: 'Ad set name' },


            { name: 'status', label: 'Status' },
            


            { name: "goal", label: "Ad Stategy CPV/CPC" },

            { name: 'target_gender', label: 'Target Gender' },
            { name: 'target_age_minimum', label: 'Target Age Minimum' },
            { name: 'target_age_maximum', label: 'Target Age Maximum' },


            { name: 'interest', label: 'Interest' },
            { name: 'creative_ad_title', label: 'Creative Ad Title' },
            { name: 'creative_ad_url', label: 'Creative Ad Url' },
            { name: 'creative_ad_description', label: 'Creative Ad Description' },
            { name: 'creative_ad_button_name', label: 'Creative Ad Button Name' },
            { name: 'creative_ad_button_color', label: 'Creative Ad Button Color' },
            { name: 'creative_ad_button_text_color', label: 'Creative Ad Button Text Color' },
            { name: 'payment_type', label: 'Payment Type' },
            { name: 'created_at', label: 'Created At' }
        ]
    ];

    const customBody = (data, column) => {

        if (column === 'total_ad_budget' || column === 'per_day_budget' || column === 'cost_per_click' || column === 'cost_per_view') {
            return (data[`${column}`]) ? `${CURRENCY}${data[`${column}`]}` : `${CURRENCY}0.00`
        } else if (column === 'clicks_per_day_estimated') {
            return CURRENCY + data.per_day_budget / data.cost_per_click;
        }
        else if (column === 'estimated_views_per_day') {
            return CURRENCY + data.per_day_budget / data.cost_per_view;
        }
        else if (column === 'is_approved') {
            return (data[`${column}`]) ? 'Approved' : 'Not Approved'
        }
        else if (column === 'ad_start' || column === 'ad_end' || column === 'created_at' || column === 'updated_at') {
            return (data[`${column}`]) ? DateFormat(data[`${column}`], 'MM-DD-YYYY HH:mm:ss') : ''
        }
        else if (column === 'location_type') {
            if (data && data[`${column}`] && data[`${column}`] === 'regional') {
                return regionLocation(data, 'target_region');
            } else if (data && data[`${column}`] && data[`${column}`] === 'local') {
                return campaignLocationMap(data, 'target_location');
            } else {
                return '';
            }
        }
        else if (column === 'interest') {

            
            if (data && data[`${column}`]) {
                const colData = JSON.parse(data[`${column}`]);
                return colData.map((item) => item.name).join(", ");
            }else if(data && data[`auto_interest`] && data[`auto_interest`] ===1){
                return 'Auto interest';
            }
        }
        return (data && data[`${column}`]) ? props.campaign[`${column}`] : '';
    }

    const insight = (props.insight) ? props.insight : null;
    const commerce = (insight && insight.Commerce) ? insight.Commerce : null;
    const audience = (insight && insight.audience) ? insight.audience : null;
    const budget = (insight && insight.budget) ? insight.budget : null;
    const social = (insight && insight.social) ? insight.social : null;
    const bookmarks = (insight && insight.bookmarks) ? insight.bookmarks : 0;
    const clicks = (insight && insight.clicks) ? insight.clicks : 0;
    const comments = (insight && insight.comments) ? insight.comments : 0;
    const likes = (insight && insight.likes) ? insight.likes : 0;
    const shares = (insight && insight.shares) ? insight.shares : 0;
    const views = (insight && insight.views) ? insight.views : 0;





    const handleStatusSubmit = () => {
      setError(false);
      if(!campaignStatus){
        setError(true);
      }
      else if (campaignStatus === 'Declined') {
          setDeclinePopup(true);
      } else {
          props.changeStatus({id:campaignId,status:campaignStatus,showMainLoading:true});
      }
  }


  const CreateiveAdUrl = ()=>{
    return (
      <a href={`//${props.campaign.creative_ad_url}`} target='_blank' rel="noopener noreferrer">
      <div className="ad-action-box" style={{background:`${props.campaign.creative_ad_button_color}`, color:`${props.campaign.creative_ad_button_text_color}`}}>
        
          <div className="ad-action-button">
            <div style={{float:'left'}}>{props.campaign.creative_ad_button_name}</div>
            <div style={{float:'right'}}><IoIosArrowForward className='add-view'/></div>
          </div>
        
      </div>
      </a>
    );
  }

    return (
      <>
        <Card>
          <CardBody className="bottomShadow">
            <Row>
              <Col sm="12" lg="5" md="6" className="profile-image">
                <>
                  <div style={{ textAlign: 'center' }}>
                    {props.campaign && props.campaign.type === 'raw_video' ? (
                      <>
                      <Card style={{ border: 'none' }}> 
                        <div className="position-relative">
                          <ReactHlsPlayer
                            src={props.campaign.creative_ad_media_path}
                            autoPlay={true}
                            controls={true}
                            width={'100%'}
                            height={'auto'}
                            hlsConfig={{
                              maxLoadingDelay: 4,
                              minAutoBitrate: 0,
                              lowLatencyMode: true,
                            }}
                          />
                          <div style={{marginTop: '-6px'}}>
                          <CreateiveAdUrl/>
                          </div>
                        </div>
                        
                      </Card>
                      
                      </>
                    ) : (
                      <>
                      <Card>
                        <div className="position-relative">
                          {(props.campaign && props.campaign.thumb_url) ||
                          props.campaign.creative_ad_media_path ? (
                            <CardImg style={{borderRadius: '0px'}}
                              src={
                                props.campaign && props.campaign.thumb_url
                                  ? props.campaign.thumb_url
                                  : props.campaign.creative_ad_media_path
                              }
                            />
                          ) : (
                            <CardImg style={{ height: 250, borderRadius: '0px' }} src={noImage} />
                          )}
                          <CardImgOverlay
                            className="bg-dark"
                            style={{ opacity: 0.2 }}
                          ></CardImgOverlay>
                          
                        </div>
                        
                      </Card>
                      <CreateiveAdUrl />
                      </>
                    )}

                    <div style={{ paddingTop: 20, textAlign: 'left' }}>
                      <DateRangePickerComp
                        buttonStyle={{ marginTop: '-3px' }}
                        lg={8}
                        md={8}
                        sm={6}
                        xs={6}
                        blg={4}
                        bmd={4}
                        bsm={6}
                        bxs={6}
                        key={'1'}
                        label={'Filter by date'}
                        handleDateChange={date => {
                          setFilters({ ...filters, [`date_range`]: date });
                        }}
                        handleSearch={() => {
                          handleSeach();
                        }}
                        defaultRange={
                          filters && filters.date_range
                            ? filters.date_range
                            : ''
                        }
                      />
                    </div>

                    <div>
                      {props.isLoading ? (
                        <Skeleton
                          variant="rect"
                          height="auto"
                          width="100%"
                          animation="wave"
                        >
                          <div style={{ height: 60 }}></div>
                        </Skeleton>
                      ) : (
                        <div style={{ display: 'flex' }}>
                          <div style={{ padding: 15 }}>
                            <MdBookmarkBorder style={{ fontSize: 20 }} />
                            <div>{bookmarks}</div>
                          </div>
                          <div style={{ padding: 15 }}>
                            <MdAdsClick style={{ fontSize: 20 }} />
                            <div>{clicks}</div>
                          </div>
                          <div style={{ padding: 15 }}>
                            <MdOutlineVisibility style={{ fontSize: 20 }} />
                            <div>{views}</div>
                          </div>

                          <div style={{ padding: 15 }}>
                            <MdOutlineFavoriteBorder style={{ fontSize: 20 }} />
                            <div>{likes}</div>
                          </div>

                          <div style={{ padding: 15 }}>
                            <MdOutlineComment style={{ fontSize: 20 }} />
                            <div>{comments}</div>
                          </div>
                          <div style={{ padding: 15 }}>
                            <MdOutlineShare style={{ fontSize: 20 }} />
                            <div>{shares}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{ height: 10 }}></div>

                  <>
                    <Card style={{ border: '1px solid #3aacd6' }}>
                      <CardHeader>Declined History</CardHeader>
                      <CardBody>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table>
                            <TableRow>
                              <TableCell style={{ padding: 5 }}>
                                <strong>Reason</strong>
                              </TableCell>
                              <TableCell style={{ padding: 5 }}>
                                <strong>Date</strong>
                              </TableCell>
                            </TableRow>

                            {props.decline_history &&
                              props.decline_history.length > 0 &&
                              props.decline_history.map((item, index) => (
                                <TableRow
                                  key={index}
                                  style={{
                                    background:
                                      index % 2 === 0 ? '#f2f2f2' : '#fff',
                                  }}
                                >
                                  <TableCell
                                    style={{ padding: 5, width: '70%' }}
                                  >
                                    {item.decline_reason}
                                  </TableCell>
                                  <TableCell style={{ padding: 5 }}>
                                    {DateFormat(item.created_at)}
                                  </TableCell>
                                </TableRow>
                              ))}
                          </Table>
                        )}
                      </CardBody>
                    </Card>
                    <div style={{ height: 10 }}></div>
                  </>

                  <div>
                    <Card style={{ border: '1px solid #3aacd6' }}>
                      <CardHeader>Social</CardHeader>
                      <CardBody>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table className="no-border">
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Profile View
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {social && social.profile_views
                                  ? social.profile_views
                                  : 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Folllow
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {social && social.follows ? social.follows : 0}
                              </TableCell>
                            </TableRow>
                          </Table>
                        )}
                      </CardBody>
                    </Card>
                    <div style={{ height: 10 }}></div>
                    <Card style={{ border: '1px solid #3aacd6' }}>
                      <CardHeader>Audience</CardHeader>
                      <CardBody>
                        <div>Gender</div>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table className="no-border">
                            <TableRow>
                              <TableCell style={{ padding: 10, width: '35%' }}>
                                Male
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                <Progress
                                  value={
                                    audience &&
                                    audience.gender &&
                                    audience.gender.male
                                      ? audience.gender.male
                                      : 0
                                  }
                                  style={{ height: '16px' }}
                                />
                                <span style={{ float: 'right' }}>
                                  {audience &&
                                  audience.gender &&
                                  audience.gender.male
                                    ? audience.gender.male
                                    : 0}
                                  %
                                </span>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Female
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                <Progress
                                  value={
                                    audience &&
                                    audience.gender &&
                                    audience.gender.female
                                      ? audience.gender.female
                                      : 0
                                  }
                                  style={{ height: '16px' }}
                                />
                                <span style={{ float: 'right' }}>
                                  {audience &&
                                  audience.gender &&
                                  audience.gender.female
                                    ? audience.gender.female
                                    : 0}
                                  %
                                </span>
                              </TableCell>
                            </TableRow>
                          </Table>
                        )}
                      </CardBody>
                      <hr></hr>
                      <CardBody>
                        <div>Age Range</div>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table className="no-border">
                            {audience &&
                              audience.age_range &&
                              audience.age_range.length > 0 &&
                              audience.age_range.map(item => (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: 10, width: '35%' }}
                                  >
                                    {item.age}
                                  </TableCell>
                                  <TableCell style={{ padding: 10 }}>
                                    <Progress
                                      value={item.percentage}
                                      style={{ height: '16px' }}
                                    />
                                    <span style={{ float: 'right' }}>
                                      {item.percentage}%
                                    </span>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </Table>
                        )}
                      </CardBody>
                      <hr></hr>
                      <CardBody>
                        <div>Location</div>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table className="no-border">
                            {audience &&
                              audience.location &&
                              audience.location.length > 0 &&
                              audience.location.map(item => (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: 10, width: '35%' }}
                                  >
                                    {item.name}
                                  </TableCell>
                                  <TableCell style={{ padding: 10 }}>
                                    <Progress
                                      value={item.percentage}
                                      style={{ height: '16px' }}
                                    />
                                    <span style={{ float: 'right' }}>
                                      {item.percentage}%
                                    </span>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </Table>
                        )}
                      </CardBody>
                    </Card>
                    <div style={{ height: 10 }}></div>
                    <Card style={{ border: '1px solid #3aacd6' }}>
                      <CardHeader>Commerce</CardHeader>
                      <CardBody>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table className="no-border">
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Impressions
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {commerce && commerce.impressions
                                  ? commerce.impressions
                                  : 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Views(only video)
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {commerce && commerce.views
                                  ? commerce.views
                                  : 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Engagements
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {commerce && commerce.engagements
                                  ? commerce.engagements
                                  : 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Clicks
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {commerce && commerce.clicks
                                  ? commerce.clicks
                                  : 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Potential Reach
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {commerce && commerce.potential_reach
                                  ? commerce.potential_reach
                                  : 0}
                              </TableCell>
                            </TableRow>
                          </Table>
                        )}
                      </CardBody>
                    </Card>
                    <div style={{ height: 10 }}></div>
                    <Card style={{ border: '1px solid #3aacd6' }}>
                      <CardHeader>Budget</CardHeader>
                      <CardBody>
                        {props.isLoading ? (
                          <Skeleton
                            variant="rect"
                            height="auto"
                            width="100%"
                            animation="wave"
                          >
                            <div style={{ height: 100 }}></div>
                          </Skeleton>
                        ) : (
                          <Table className="no-border">
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Spend
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                $
                                {budget && budget.budgetSpend
                                  ? budget.budgetSpend
                                  : 0}
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Spend %
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {budget && budget.spendPercentage
                                  ? budget.spendPercentage
                                  : 0}
                                %
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Avg Cost Per Impression
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {budget && budget.cost_per_impression
                                  ? budget.cost_per_impression
                                  : 0}
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ padding: 10 }}>
                                Avg Cost Per Click
                              </TableCell>
                              <TableCell style={{ padding: 10 }}>
                                {budget && budget.cost_per_click
                                  ? budget.cost_per_click
                                  : 0}
                              </TableCell>
                            </TableRow>
                          </Table>
                        )}
                      </CardBody>
                    </Card>
                  </div>
                </>
              </Col>

              <Col sm="12" lg="7" md="6">
                <Row>
                  <Col sm="12" lg="4">
                    <Button
                      color="primary"
                      style={{ padding: 'auto', width: 100, marginTop: 20 }}
                      size="sm"
                      onClick={() => navigate(-1)}
                      block
                    >
                      Back
                    </Button>
                  </Col>
                </Row>

                <div>
                  <p style={{ color: '#00aee4' }}>
                    Current Status: {props.campaign.status}
                  </p>
                  <Form>
                    <Row>
                      <Col sm="12" lg="6" md="6">
                        <Input
                          onChange={e => {
                            if (e.target.value) setError(false);
                            setCampaignStatus(e.target.value);
                          }}
                          className="mb-2"
                          type="select"
                          defaultValue={
                            props.campaign && props.campaign.status
                              ? props.campaign.status
                              : ''
                          }
                          style={{ width: 200, display: 'inline' }}
                        >
                          <option value={0}>Select Status</option>
                          {['Pending', 'Approved', 'Declined', 'Paused'].map(
                            item => (
                              <option key={item} value={item}>
                                {item}
                              </option>
                            ),
                          )}
                        </Input>
                        {error && (
                          <FormFeedback>
                            Please select status first
                          </FormFeedback>
                        )}
                      </Col>
                      <Col sm="12" lg="6" md="6">
                        <Button
                          onClick={handleStatusSubmit}
                          style={{
                            padding: 10,
                          }}
                          color="primary"
                          size="lg"
                          className="border-0"
                        >
                          Change Status
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>

                {columnsData.map(columns => (
                  <>
                    <Table style={{ border: '1px solid #3aacd6' }}>
                      {columns.map((item, index) =>
                        item.colType && item.colType === 'single' ? (
                          <TableRow
                            key={index}
                            style={{
                              color: item.highlight ? '#00aee4' : '',
                              background: index % 2 === 0 ? '#f2f2f2' : '#fff',
                            }}
                          >
                            <TableCell colspan="2" style={{ padding: 10 }}>
                              {' '}
                              {customBody(props.campaign, item.name)}{' '}
                            </TableCell>
                          </TableRow>
                        ) : (
                          <TableRow
                            key={index}
                            style={{
                              color: item.highlight ? '#00aee4' : '',
                              background: index % 2 === 0 ? '#f2f2f2' : '#fff',
                            }}
                          >
                            <TableCell style={{ padding: 10, width: '40%' }}>
                              {' '}
                              {item.label}{' '}
                            </TableCell>
                            <TableCell style={{ padding: 10 }}>
                              {' '}
                              {customBody(props.campaign, item.name)}{' '}
                            </TableCell>
                          </TableRow>
                        ),
                      )}
                    </Table>
                    <br />
                  </>
                ))}
              </Col>
            </Row>
          </CardBody>
        </Card>

        <PopupWindow
          hideButton={true}
          buttonStyle={{ marginTop: 10, width: '100%' }}
          handlePopup={popup => {
            setDeclinePopup(popup)
          }}
          openWindow={declinePopup}
          title={'Decline Reason'}
          launchButtonText={'Change Status'}
        >
          <div>
            <div style={{ display: 'flex' }}>
              {props.loading ? (
                <PageSpinner
                  style={{
                    position: 'absolute',
                    height: 'auto',
                    zIndex: '999',
                  }}
                />
              ) : (
                ''
              )}
              <Form style={{ width: '100%' }}>
                <FormGroup>
                  <Input
                    value={declineReason}
                    onChange={e => {
                      setDeclineReason(e.target.value)
                    }}
                    type="textarea"
                    name="text"
                    id="exampleText"
                    style={{ width: '100%' }}
                  />
                </FormGroup>
                {declineError && (
                  <FormGroup>
                    <FormFeedback>Please add a reason</FormFeedback>
                  </FormGroup>
                )}
                <Button
                  onClick={() => {
                    setDeclineError(false);
                    if (!declineReason) {
                      setDeclineError(true);
                    } else {
                      let selectedCampaign = { id:campaignId,decline_reason:declineReason,status:'Declined'  };
                      props.changeStatus(selectedCampaign);
                    }
                  }}
                  color="primary"
                  size="lg"
                  className="border-0"
                >
                  Decline
                </Button>
              </Form>
            </div>
          </div>
        </PopupWindow>
      </>
    );
}

const mapStateToProps = (state) => ({
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    campaign: (state.campaign &&
        state.campaign.details &&
        state.campaign.details.data) ? state.campaign.details.data : [],


    insight: (state.campaign &&
        state.campaign.campaignInsight &&
        state.campaign.campaignInsight.data && state.campaign.campaignInsight.data.insight) ? state.campaign.campaignInsight.data.insight : [],

    decline_history: (state.campaign &&
        state.campaign.campaignInsight &&
        state.campaign.campaignInsight.data && state.campaign.campaignInsight.data.decline_history) ? state.campaign.campaignInsight.data.decline_history : [],


    campaignApproved: (state.campaign &&
        state.campaign.campaignApproved) ? state.campaign.campaignApproved : [],

    statusUpdated: (state.campaign && state.campaign.statusUpdated) ? state.campaign.statusUpdated : undefined,
});
const mapDispatchToProps = (dispatch) => ({
    getCampaignsData: (payload) => dispatch(CampaignAction.getCampaignsData(payload)),
    approveCampaign: (payload) => dispatch(CampaignAction.approveCampaign(payload)),
    getCampaignInsight: (payload) => dispatch(CampaignAction.getCampaignInsight(payload)),
    changeStatus: (payload) => dispatch(CampaignAction.changeStatus(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetails);